import { useIntl, useDispatch, getLocale, useSelector } from 'umi';
import { FILTER_NAMESPACE } from '@/pages/intelligence/models/filter';
import { IRegion } from '@/pages/intelligence/types/common';
import { useEffect, useMemo, useState } from 'react';

export const MarketSpecailType = {
  rpd: 'rpd',
  mobliePheat: 'moblie_pheat',
  retention: 'retention',
  metricTable: 'metricTable',
  digitalRevenue: 'digitalRevenue',
  common: 'common',
  TopCompanies: 'top-companies',
  PCGamesDetailsStoreRank: 'pc-games-details-store-rank',
  gsd: 'gsd',
};

export const CommonFilterType = {
  rpd: 'rpd',
  mobliePheat: 'moblie_pheat',
  retention: 'retention',
  metricTable: 'metricTable',
  digitalRevenue: 'digitalRevenue',
  common: 'common',
  TopCompanies: 'top-companies',
  PCGamesDetailsStoreRank: 'pc-games-details-store-rank',
  gsd: 'gsd',
};

export default function useMarketSelector(props: {
  filterType?: string;
  // 处理接口返回的数据 为 国家筛选器组件 需要的标准数据，具体格式看IRegion类型定义
  formatter?: (data: any) => IRegion[];
}) {
  const { filterType = MarketSpecailType.common, formatter } = props || {};

  const dispatch = useDispatch();
  const {
    commonMarketFilter,
    rpdMarketFilter,
    retentionMarketFilter,
    mobilePheatMarketFilter,
    digitalRevenueMarketFilter,
    metricsTableMarketFilter,
    topCompaniesMarketFilter,
    pcGamesDetailsStoreRankMarketFilter,
    gsdMarketFilter,
  } = useSelector((state) => {
    // @ts-ignore
    const {
      commonMarketFilter,
      rpdMarketFilter,
      retentionMarketFilter,
      mobilePheatMarketFilter,
      digitalRevenueMarketFilter,
      metricsTableMarketFilter,
      topCompaniesMarketFilter,
      pcGamesDetailsStoreRankMarketFilter,
      gsdMarketFilter,
    } = state[FILTER_NAMESPACE];
    return {
      commonMarketFilter,
      rpdMarketFilter,
      retentionMarketFilter,
      mobilePheatMarketFilter,
      digitalRevenueMarketFilter,
      metricsTableMarketFilter,
      topCompaniesMarketFilter,
      pcGamesDetailsStoreRankMarketFilter,
      gsdMarketFilter,
    };
  });

  const modelValueName = () => {
    const params = {
      type: [{ tabName: 'mobile' }],
      item: [{ tabName: '' }],
      /* filter_type: common(通用)，rpd,retention, 不发默认common*/
      // "filter_type": "rpd",
    };

    if (filterType === MarketSpecailType.rpd) {
      return {
        modelName: rpdMarketFilter,
        dispatchType: `${FILTER_NAMESPACE}/getRpdMarketFilter`,
        payload: { ...params, filter_type: 'rpd' },
      };
    }
    if (filterType === MarketSpecailType.retention) {
      return {
        modelName: retentionMarketFilter,
        dispatchType: `${FILTER_NAMESPACE}/getRetentionMarketFilter`,
        payload: { ...params, filter_type: 'retention' },
      };
    }
    if (filterType === MarketSpecailType.mobliePheat) {
      return {
        modelName: mobilePheatMarketFilter,
        dispatchType: `${FILTER_NAMESPACE}/getMobilePheatMarketFilter`,
        payload: { filter_type: 'moblie_pheat' },
      };
    }
    if (filterType === MarketSpecailType.digitalRevenue) {
      return {
        modelName: digitalRevenueMarketFilter,
        dispatchType: `${FILTER_NAMESPACE}/getDigitalRevenueMarketFilter`,
        payload: { ...params, filter_type: 'digital_revenue' },
      };
    }
    if (filterType === MarketSpecailType.metricTable) {
      return {
        modelName: metricsTableMarketFilter,
        dispatchType: `${FILTER_NAMESPACE}/getMetricsTableMarketFilter`,
        payload: { ...params, filter_type: 'metric_table' },
      };
    }
    if (filterType === MarketSpecailType.TopCompanies) {
      return {
        modelName: topCompaniesMarketFilter,
        dispatchType: `${FILTER_NAMESPACE}/getTopCompaniesMarketFilter`,
        payload: {
          type: 'mobile',
          formatter,
        },
      };
    }
    if (filterType === MarketSpecailType.PCGamesDetailsStoreRank) {
      return {
        modelName: pcGamesDetailsStoreRankMarketFilter,
        dispatchType: `${FILTER_NAMESPACE}/getPCGamesDetailsStoreRankMarketFilter`,
        payload: {
          sources: ['steam top sellers'],
        },
      };
    }
    if (filterType === MarketSpecailType.gsd) {
      return {
        modelName: gsdMarketFilter,
        dispatchType: `${FILTER_NAMESPACE}/getGSDMarketFilter`,
        payload: {
          type: [{ tabName: 'pc' }],
          item: [{ tabName: '' }],
          filter_type: 'gsd',
        },
      };
    }
    // 不需要调用接口数据
    if (filterType === 'NOT_REQUIRED') {
      return;
    }
    return {
      modelName: commonMarketFilter,
      dispatchType: `${FILTER_NAMESPACE}/getCommonMarketFilter`,
      payload: { ...params, filter_type: 'common' },
    };
  };

  const modelMsg = modelValueName();
  const [regionOptions, setRegionOptions] = useState<any>(null);
  const [filterLoading, setFilterLoding] = useState(true);

  useEffect(() => {
    // 不能用!val， 因为它可能是undefind
    if (modelMsg?.modelName?.loading === false) {
      getMarketFilterApiData();
    }
  }, [modelMsg?.modelName?.loading]);

  const getMarketFilterApiData = async () => {
    const { modelName, dispatchType, payload } = modelMsg;
    if (modelName.loading === false && modelName.data === null) {
      try {
        setFilterLoding(true);
        // 如果数据为空则重新请求接口
        const res = await dispatch({
          type: dispatchType,
          payload,
        });
        setRegionOptions(res);
        setFilterLoding(false);
      } catch (err) {
        setFilterLoding(false);
      }
    } else {
      setFilterLoding(false);
      setRegionOptions(modelName.data);
    }
  };

  return {
    filterLoading,
    regionOptions,
  };
}
